import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const LookupTypesProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `LookupType/GetByCategoryName/${props.categoryName}`, method: 'GET', secure: true });
    }, [execute]);  

    const value = { listRecords, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useLookupTypesStore = () => React.useContext(Context);
